/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Unit_Suffix_DayInputs */

const cs_price_unit_suffix_day = /** @type {(inputs: Price_Unit_Suffix_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/den`)
};

const en_price_unit_suffix_day = /** @type {(inputs: Price_Unit_Suffix_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/day`)
};

/**
* | output |
* | --- |
* | "/day" |
*
* @param {Price_Unit_Suffix_DayInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const price_unit_suffix_day = /** @type {((inputs?: Price_Unit_Suffix_DayInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Unit_Suffix_DayInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_price_unit_suffix_day(inputs)
	return cs_price_unit_suffix_day(inputs)
});